import { Card, CardContent } from '@crm/ui';
import { PlanSummary, planLimits } from '@/modules/billing';
import type { SubscriberDetail } from '../api';

export function SubscriberPlan({ detail }: { detail: SubscriberDetail }) {
  return (
    <div className="space-y-4">
      <PlanSummary
        plan={detail.plan}
        startedAt={detail.planStartedAt}
        emptyDescription="O assinante usa o sistema sem estar sendo cobrado."
      >
        {detail.plan ? (
          <p className="text-sm text-muted-foreground">{planLimits(detail.plan)}</p>
        ) : null}
      </PlanSummary>

      <Card variant="flush">
        <CardContent className="py-4">
          <p className="text-sm text-muted-foreground">
            A troca de plano e feita pelo salao, em Gestao - Licenca do sistema.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
